import { Button, EmptyState, ResourceOptions } from "@ondit/ui";
import { useState } from "react";
import { Link } from "react-router";
import { pick, useI18n, useT } from "~/core/i18n";
import { article as articlePath } from "~/core/paths";
import { type ReadingProps, StageShell } from "~/modules/analytics/components/stage";
import templates from "../../../../../packages/content/writing-templates.json";

export function TemplatesPage({ entityId, filters, setFilters }: ReadingProps) {
	const t = useT();
	const { locale } = useI18n();
	const [search, setSearch] = useState("");
	const matches = templates.filter((item) =>
		`${item.name.join(" ")} ${item.description.join(" ")}`.toLowerCase().includes(search.trim().toLowerCase()),
	);
	return (
		<StageShell
			entityId={entityId}
			reading="templates"
			filters={filters}
			setFilters={setFilters}
			lede={t("templates.lede")}
		>
			<ResourceOptions
				translate={t}
				className="analytics-table-tools"
				search={{ value: search, onChange: setSearch, placeholder: t("templates.search") }}
			/>
			{matches.length === 0 ? (
				<EmptyState
					title={t("table.noMatch")}
					action={
						<Button variant="default" onClick={() => setSearch("")}>
							{t("filter.clear")}
						</Button>
					}
				/>
			) : null}
			<div className="templates template-library">
				{matches.map((item) => (
					<article className="template-card" key={item.id}>
						<h2>{pick(locale, item.name)}</h2>
						<p className="faint">{pick(locale, item.description)}</p>
						<Button asChild variant="default">
							<Link to={articlePath(entityId, undefined, { template: item.id })}>{t("templates.use")}</Link>
						</Button>
					</article>
				))}
			</div>
		</StageShell>
	);
}
